import InitView, { onRequireValidation, chargeBankAccount } from "./init";
import SuccessView from "../../../common/success";
import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath, isPlainObject } from "../../../../../utils";

export default function view() {
  const $this = this;
  const { DATA, $charge, $inputs } = this;

  return (view = ViewFactory({
    NAME: 'BANK_OTP_VIEW',
    inputs: ['otp'],
    mutables: { instruction: 'VALIDATE_INSTRUCTION', canResendOTP: 'CAN_RESEND_OTP' },
    constants: {
      resendOTP() {
        return ($this.CAN_RESEND_OTP === true)
          ? chargeBankAccount.call($this)
          : Promise.resolve(false);
      }
    },
    next() {
      const {
        charge: transactionreference = null
      } = isPlainObject($this.reference) ? $this.reference : {};

      const otp = getValueAtPath($inputs, '[otp].value');
      const bank = getValueAtPath($inputs, '[bank].value.code');

      if (otp) {
        const data = { otp, transactionreference };

        data['validateparameter'] = 'OTP';

        if (['044', '050'].indexOf(bank) >= 0) {
          data['use_access'] = true;
        }

        $charge.validate({
          data,
          onBegin() { $this.SHOULD_VALIDATE_CHARGE = false },
          onRequireValidation: onRequireValidation.call($this),
          onValidateSuccessful() { SuccessView && SuccessView.activate.call($this) },
          onComplete() { /* self.console.log({ ...$this }) */ $this.clearResendTimer() }
        });
      }
    },
    back() {
      const currency = getValueAtPath(DATA, 'currency') || 'NGN';
      currency === 'NGN' && (InitView && InitView.activate(), $inputs.$reset());
    }
  }).call(this));
}
